import Locked from './Locked';

export { Locked };
